import {
    FETCH_LEDMODULE,

    CREATE_LEDMODULE,
    UPDATE_LEDMODULE,
    DELETE_LEDMODULE,
    RESET_LEDMODULE,

    FETCH_ORIGINAL_LEDMODULE,

    DOWNLOAD_LEDMODULE,

    FETCH_LEDMODULE_FEATURES,
    FETCH_LEDMODULE_PROPERTIES,

    COPY_LEDMODULE,
    SET_TEMPORARY_LEDMODULE,
    RESET,
    ISSUES_ADD,
} from '../actions/types';
import { getIssuesByProperty } from '../utils/validationSummary';

const INITIAL_STATE = {
    info: null,

    features: null,
    properties: null,

    propertiesShadow: null,

    original: null,

    file: null,

    validationSummary: null,
    issueByProperty: {},
    downloadId: null,
    isTemporary: false,
    options: null,
};

export default (state = INITIAL_STATE, action) => {
    switch (action.type) {
        case CREATE_LEDMODULE:
            return Object.assign({}, state, {
                info: { id: action.payload },
            });

        case UPDATE_LEDMODULE:
            if (Number.isInteger(action.payload)) {
                return Object.assign({}, state, {
                    info: { id: action.payload },
                });
            } else {
                return Object.assign({}, state, {
                    info: action.payload,
                    properties: action.payload.properties,
                });
            }
        case FETCH_LEDMODULE:
        case FETCH_LEDMODULE_PROPERTIES:
            return Object.assign({}, state, {
                info: action.payload,
                properties: action.payload.properties,
            });
        
        case FETCH_LEDMODULE_FEATURES:
            return Object.assign({}, state, {
                features: action.payload,
            });

        case SET_TEMPORARY_LEDMODULE:
            return Object.assign({}, state, {
                isTemporary: action.payload,
            });

        case COPY_LEDMODULE: {
            return Object.assign({}, state, {
                info: { id: action.payload },
            });
        }
        case FETCH_ORIGINAL_LEDMODULE:

            action.payload.isPublished = false;
            action.payload.type = "P";

            return Object.assign({}, state, {
                info: action.payload,
                properties: action.payload.properties,
                original: action.payload,
            });

        case DOWNLOAD_LEDMODULE: 
            return Object.assign({}, state, {
                file: action.payload,
            });

        case ISSUES_ADD:

            const m = {
                "messages": action.payload,
                "isValid": action.payload.length === 0,
                "warningCount": 0,
                "errorCount": action.payload.length
            };
            return Object.assign({}, state, {
                validationSummary: m,
                issueByProperty: getIssuesByProperty(m),
            });

        case DELETE_LEDMODULE:
        case RESET:
        case RESET_LEDMODULE:
            return INITIAL_STATE;
        default:
            return state;
    }
};